import { render, staticRenderFns } from "./RsaDynamicBodyAreaComponents.vue?vue&type=template&id=45307fac&scoped=true"
import script from "./RsaDynamicBodyAreaComponents.vue?vue&type=script&lang=js"
export * from "./RsaDynamicBodyAreaComponents.vue?vue&type=script&lang=js"
import style0 from "./RsaDynamicBodyAreaComponents.vue?vue&type=style&index=0&id=45307fac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45307fac",
  null
  
)

export default component.exports